import { createSelector } from 'reselect';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

// append /app to support default dashboards set before single app change
export const defaultPathSelector = createSelector(
  selector,
  store => (store.path.startsWith('/app') ? store.path : `/app${store.path}`),
);

export default selector;
